<template>
  <div>
    <Modal v-model="modifyPasswordModal"
           width="380"
           :mask-closable="false"
           :closable="passwordStatus !== 'expired'">
      <p slot="header" style="color: #ff994f;">
        <Icon type="information-circled"></Icon>
        <span>修改密码</span>
      </p>
      <div>
        <Form ref="modifyPassword" :rules="modifyPasswordFormValid" :model="modifyUserInfo" :label-width="90" label-position="right">
          <FormItem label="用户名"><Input v-model="modifyUserInfo.userName" disabled /></FormItem>
          <FormItem label="原密码" prop="old_password"><Input type="password" v-model="modifyUserInfo.old_password" /></FormItem>
          <FormItem label="密码" prop="new_password"><Input type="password" v-model="modifyUserInfo.new_password" placeholder="6位以上" /></FormItem>
          <FormItem label="请重复密码" prop="new_password_confirmation">
            <Input type="password" v-model="modifyUserInfo.new_password_confirmation" placeholder="6位以上" />
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" size="large" long @click="modifyPassword">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      // modifyPasswordModal: true,
      modifyPasswordFormValid: {
        old_password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { type: 'string', min: 6, message: '请输入至少6位密码', trigger: 'blur' },
          { validator: this.checkPwdEqual, trigger: 'blur' }
        ],
        new_password_confirmation: [
          { required: true, message: '请输入重复的新密码', trigger: 'blur' },
          { type: 'string', min: 6, message: '请输入至少6位密码', trigger: 'blur' },
          { validator: this.checkPwdEqual, trigger: 'blur' }
        ]
      },
      modifyUserInfo: {
        userName: localStorage.getItem('userInfo') && JSON.parse(localStorage.getItem('userInfo')).name || '',
        old_password: '',
        new_password: '',
        new_password_confirmation: ''
      },
      needEditStatus: { // 需要更改密码的状态
        near_expiration: 'near_expiration',
        expired: 'expired'
      },
      passwordStatusObj: { // 密码状态说明
        normal: '正常',
        near_expiration: '即将过期',
        expired: '已过期'
      },
    };
  },
  computed: {
    modifyPasswordModal () {
      return this.passwordStatus !== 'normal'
    },
    passwordStatus () {
      let status = this.$store.getters.getpasswordStatus.status || 'normal'
      if (status !== 'normal') {
        this.$message({
          showClose: true,
          message: '密码'+ this.passwordStatusObj[status] +'，请修改密码',
          type: 'error'
        })
      }
      return status
    }
  },
  methods: {
    checkPasswordStatus() { // 获取密码状态
      if (!localStorage.getItem('userInfo')) return
      this.$store.commit('FetchGetAdminPasswordStatus', {
        params: {},
        successFunc: res => {
          console.log('密码状态成功', res)
          this.$store.dispatch('setpasswordStatus', {status: res.data.status})
        },
        failFunc: (res) => {
          console.log('密码状态失败', res)
          this.$store.dispatch('setpasswordStatus', {status: 'normal'})
        }
      });
    },
    timerCheckPassword() { // 定时器
      this.checkPasswordStatus()
      this.timer = setInterval(() => {
        let time = new Date()
        let hh = time.getHours() < 10 ? '0' + time.getHours() : time.getHours()
        let mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()
        // console.log(`${hh}:${mm}`)
        if (`${hh}:${mm}` === '09:00' || `${hh}:${mm}` === '12:00' || `${hh}:${mm}` === '18:00') {
          this.checkPasswordStatus()
        }
      }, 60000)
    },
    modifyPassword() {
      const _self = this;
      console.log('this.$refs', this.$refs)

      this.$refs.modifyPassword.validate(valid => {
        if (valid) {
          this.$store.commit('modifyPassword', {
            data: _self.modifyUserInfo,
            successFunc(res) {
              _self.$Notice.success({
                title: res.message,
                duration: 1.5,
                onClose() {
                  localStorage.removeItem('userInfo');
                  _self.$store.dispatch('setpasswordStatus', {status: 'normal'})
                  _self.modifyPasswordModal = false
                  _self.$router.push('/login');
                }
              });
            }
          });
        }
      });
    },
    closeModal () {
      this.modifyPasswordModal = false
    }
  },
  mounted () {
    this.timerCheckPassword()
  },
  created() {
    // this.$store.dispatch('setpasswordStatus', {status: 'normal'})
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/update-password/update-password.vue